import { AdminUserAddressInfoModel } from "./user_address_info_model.js"
import { RawAdminUserModel } from "./user_model.js";

class RawAdminAddressUserModel extends RawAdminUserModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "personalInfo",
        type: "nestedModel",
        model: AdminUserAddressInfoModel,
        weight: 12,
      }
    ]
  }
}
const AdminAddressUserModel = new RawAdminAddressUserModel();

export { RawAdminAddressUserModel, AdminAddressUserModel }
